import React from 'react';

import Button from '../../Button/Button';
import { cn } from '../../lib/utils';
import Typography from '../../Typography/Typography';
import Header from '../Header/Header';

import { useCountdownTimer } from './use-countdown-timer.hook';

export interface LockoutScreenProps {
  lockoutEndTime: Date;
  onContactSupport?: () => void;
  onLockoutEnd?: () => void;
  className?: string;
}

const LockoutScreen: React.FC<LockoutScreenProps> = ({
  lockoutEndTime,
  onContactSupport,
  onLockoutEnd,
  className
}) => {
  const timeRemaining = useCountdownTimer(lockoutEndTime, onLockoutEnd);

  const formatTime = (value: number): string => {
    return value.toString().padStart(2, '0');
  };

  return (
    <div className={cn('w-full max-w-[335px] mx-auto', className)}>
      <div className="flex flex-col space-y-4 items-center">
        <Header
          title="Account temporarily locked"
          subtitle="Too many failed attempts. Please try again in:"
        />

        <div className="flex flex-col items-center justify-center w-full h-[114px] rounded-lg bg-[rgba(255,236,236,0.4)]">
          <Typography
            tag="h2"
            className="text-[24px] font-bold leading-[32px] text-base-destructive"
          >
            {formatTime(timeRemaining.minutes)}:
            {formatTime(timeRemaining.seconds)}
          </Typography>
          <Typography className="text-p-s text-base-destructive">
            Minutes remaining
          </Typography>
        </div>

        <div className="space-y-2 w-full">
          <Typography className="text-center text-p-s text-base-mutedForeground mt-2">
            Need help? Contact our support team.
          </Typography>
          <Button
            type="button"
            variant="outline"
            onClick={onContactSupport}
            className="w-full"
          >
            Contact Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LockoutScreen;
